export default __webpack_public_path__ + "static/media/DAIF_Extra3_Loop.49da2dc2.mp4";